import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getSessionCart, setCompletedPagesForHPB, setCurrentFlowForHPB, setMinLicenseForBuss, setStoreHelciumProductId } from 'app/ducks/GlobalSlice';
import { useDispatch } from 'react-redux'
import { checkIfAemExists } from 'utils/commonUtils';
import { useTranslation } from 'react-i18next';

const MarketPlace = () => {
    const { t, ready } = useTranslation(["app"], { useSuspense: false });
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mobilityData = useSelector(state=>state.MobilityPage)
    const globalData = useSelector((state) => state.GlobalData);
    const [isAddonAlreadyExist, setIsAddonAlreadyExist] = useState(false);
    const [metaTag,setMetaTag] = useState(undefined)
    const enableMarketPlace = checkIfAemExists(t("enableMarketPlace", { ns: 'app' }))
    const googleWorkspace = "google workspace";
    const packages =
    globalData?.sessionCartData?.apiResponse?.prospectFlowData?.cart?.packages;
    useEffect(()=>{
        const metaWithNoIndex = document.querySelector("[content='noindex, nofollow']")
        if(metaWithNoIndex){
        localStorage.setItem("metaWithNoIndex", "[content='noindex, nofollow']")
        metaWithNoIndex.remove();
        }
        return async()=>{
            const metaWithNoIndexF = localStorage.getItem("metaWithNoIndex")
            if(metaWithNoIndexF){
                const metaTag = document.createElement("meta")
                metaTag.name = "robots"
                metaTag.content = "noindex, nofollow"
                document.head.appendChild(metaTag)
                localStorage.removeItem("metaWithNoIndex")
            }
        }
    },[])
    useEffect(()=>{
        if(ready && !enableMarketPlace) navigate("/shop/products/devices/all")
    },[ready,enableMarketPlace])

    useEffect(()=>{
        let addonGoogleExist = Object.values(packages || {}).find((pkg) => {
            if(pkg?.buss == false){
                for(let key in pkg?.features){
                    if(pkg?.features[key].featureDesc.toLowerCase().includes(googleWorkspace)){
                        return true;
                    }
                }
            }
        } )
        if(!!addonGoogleExist) {
          setIsAddonAlreadyExist(true);
        }else{
          setIsAddonAlreadyExist(false);
        }
    },[packages])

    React.useEffect(()=>{
        const scriptE = document.createElement("script")
        scriptE.src = window.mbtGlobal?.marketPlaceMfeUrl//"https://b2bqa2.sdc.vzwcorp.com/prospect-marketplace/prospect-marketplace.js";
        scriptE.defer = true
        scriptE.async = true
        document.body.appendChild(scriptE)
    }, [])

    window.addEventListener("addToCartCompletedInMarketPalce",function(e){
        if(String(window.location.pathname).includes("/marketplace")){
        if(e && e.detail && e.detail.minLicense) dispatch(setMinLicenseForBuss(e.detail.minLicense))
        if(e && e.detail && e.detail.storeHelciumProductId) dispatch(setStoreHelciumProductId(e.detail.storeHelciumProductId))
        dispatch(setCurrentFlowForHPB('labelForMarketplaceFlow'))
        let completedPages = [...globalData.completedPagedForHPB]
        if (!completedPages.includes("shop/marketplace")) completedPages.push("shop/marketplace")
        dispatch(setCompletedPagesForHPB(completedPages))
        e.preventDefault()
        e.stopPropagation()
        dispatch(getSessionCart())
        navigate("/shop/shopping-cart")
        }
    },{once:true})

    window.addEventListener("shopWirelessFromBuss",function(e){
        if(String(window.location.pathname).includes("/marketplace")){
        e.preventDefault()
        e.stopPropagation()
        navigate("/shop/products/devices/all")
        }
    },{once:true})

    window.addEventListener("shopBusinessInternetFromBuss",function(e){
        if(String(window.location.pathname).includes("/marketplace")){
        e.preventDefault()
        e.stopPropagation()
        navigate("/shop/solutions/qualification")
        }
    },{once:true})
    return(
        <div>
            <prospect-marketplace flow="" clientId="react" companyName="marketplace"
                ecpdId=" "
                mbaUserId=" "
                mbaUserEmail=""
                mbtSessionId=" "
                mbaRole=" "
                type="softwares"
                fromProspect="true"
                selectedPack={mobilityData?.selectedPackForBUSS}
                clientName="MBP"
                packages={packages}
                isAddonAlreadyExist={isAddonAlreadyExist}></prospect-marketplace>
        </div>
    )
}


export default MarketPlace